// src/pages/Home.js
import React from "react";
import Hero from "../components/Hero";
import AboutSection from "../components/AboutSection";
import ServicesSection from "../components/ServicesSection";
import IndustriesSection from "../components/IndustriesSection";
import CaseStudySection from "../components/CaseStudySection";


const Home = () => {
  return (
    <>
      <Hero />
      <AboutSection />
      <ServicesSection />
      <IndustriesSection />
      <CaseStudySection />
    </>
  );
};

export default Home;
